import * as angular from 'angular';
import { filter, first, map } from 'rxjs/operators';
import { isPresent } from '@mode/shared/util-js';
import { DataViewFacade } from '@mode/switch-views/contract';

import ViewService from '../../services/view-service';
import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';

class EmptyNoteBookController {
  static $inject = ['DataViewFacade', 'ViewService', 'ThoughtspotIntegrationService'];

  public queryToken: string;
  public isIntegrated = this.thoughtspotIntegrationService.currOrgIntegrated();

  constructor(
    private dataViewFacade: DataViewFacade,
    private viewService: ViewService,
    private thoughtspotIntegrationService: ThoughtspotIntegrationService
  ) {}

  $onInit() {
    this.dataViewFacade.enhancedDatasetResults$
      .pipe(
        filter(isPresent),
        map((datasets) => datasets[0]),
        first()
      )
      .subscribe(({ queryToken }) => {
        this.queryToken = queryToken;
      });
  }

  goToEditor() {
    this.viewService.toggleQueryMode(true);
  }
}

const emptyNotebookComponent: angular.IComponentOptions = {
  controller: EmptyNoteBookController,
  controllerAs: 'ctrl',
  template: `
  <div class="empty-report-msg">
    <capra-icon ng-if="ctrl.isIntegrated" icon="illo-generic-empty-state"></capra-icon>
    <div ng-if="!ctrl.isIntegrated" class="icon-notebook-empty-state"></div>
    <h1>Let&rsquo;s get some data in here</h1>
    <p>
      To use this Notebook, first write a SQL query.
      <br>
      Then, you can access the results of your query using Python or R here.
    </p>
    <a
      ng-if="ctrl.queryToken"
      ui-sref="application.reports.edit.queries.new({queryToken: ctrl.queryToken})"
      href="#"
      ng-click="ctrl.goToEditor()"
      class="btn btn-primary btn-lg">
      Write a Query
    </a>
  </div>
  `,
};

angular.module('mode.components').component('emptyNotebook', emptyNotebookComponent);
